import { Button, Radio } from 'antd';

import type { AxisOptionGroup } from 'components/molecules/PackArchitecture/AxisConfigDropdown';

type AxisConfigDropdownPanelProps = {
    optionGroups: AxisOptionGroup[];
    draftValue: string;
    onDraftChange: (value: string) => void;
    onApply: () => void;
};

const PANEL_WIDTH: Record<number, string> = {
    1: 'w-[280px]',
    2: 'w-[400px]',
    3: 'w-[568px]',
    4: 'w-[736px]',
};

const GRID_COLS: Record<number, string> = {
    1: 'grid-cols-1',
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-4',
};

const AxisConfigDropdownPanel = ({
    optionGroups,
    draftValue,
    onDraftChange,
    onApply,
}: AxisConfigDropdownPanelProps) => {
    const colCount = Math.min(optionGroups.length, 4) as 1 | 2 | 3 | 4;
    const panelWidth = PANEL_WIDTH[colCount] ?? 'w-[568px]';
    const gridCols = GRID_COLS[colCount] ?? 'grid-cols-4';

    return (
    <div className={`${panelWidth} overflow-hidden rounded-lg border border-borderSecondary bg-white p-4 pb-0 shadow-axesDropdown`}>
        <div className={`grid ${gridCols} divide-x divide-backgroundGreyAlt1`}>
            {optionGroups.map((group) => (
                <div
                    key={group.title}
                    className="flex min-w-0 flex-col gap-3 p-[14px] pt-0"
                >
                    {colCount > 1 ? (
                        <p className="m-0 text-sm font-semibold leading-[22px] text-axisGroupTitle">{group.title}</p>
                    ) : null}
                    <Radio.Group
                        value={draftValue}
                        onChange={(event) => onDraftChange(event.target.value)}
                        className="!flex !flex-col !gap-[8px] [&>.ant-radio-wrapper]:!m-0 [&>.ant-radio-wrapper]:!text-sm [&>.ant-radio-wrapper]:!leading-[24px] [&>.ant-radio-wrapper]:!text-blackAlt [&>.ant-radio-wrapper>span:last-child]:!py-0 [&>.ant-radio-wrapper>span:last-child]:!pl-3 [&>.ant-radio-wrapper>span:last-child]:!pr-0"
                    >
                        {group.options.map((option) => (
                            <Radio key={option.value} value={option.value}>
                                {option.label}
                            </Radio>
                        ))}
                    </Radio.Group>
                </div>
            ))}
        </div>
        <div className="mt-4 flex items-center justify-end border-t border-backgroundGreyAlt1">
            <Button
                type="primary"
                onClick={onApply}
                className="!my-4 !h-auto !rounded-[6px] !px-4 !py-[5px] !text-sm !font-medium"
            >
                Apply
            </Button>
        </div>
    </div>
    );
};

export default AxisConfigDropdownPanel;
